import React, { useMemo } from "react";
import MirsTable from "components/general/table/Table";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import Competitor from 'components/presentation/Competitor';
import { dateFormat } from "helpers/utils"
import { isParalympic, CompetitionFromStore } from 'helpers/utils'
import { NocMemo as Noc } from "components/presentation/Noc";
import SportCode from "components/common/SportCode"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { TableExpanded } from "./RecordPrototypeTableExpanded";
import LoaderSubComponent from "./LoaderSubComponent";
import { ColumnExpander } from "components/common/TableColumns";


const RecordsPrototype = (props) => {

    const { records, forceResultTypeHader, forceMobileColumns, headerRecord, hasTableExpanded, config } = props;

    let recordsData = []

    records?.forEach(record => {
        const newObject = JSON.parse(JSON.stringify(record));
        record?.recordDataFiltered?.forEach(
            rData => {
                newObject.recordDataFiltered = rData;
                //newObject.participant={}
                //newObject.participant.code = rData?.competitor?.participant?.code;
                recordsData.push(newObject);
            }
        );
    });

    const { breakPoint } = useViewport();

    const { mirs_discipline } = useUrlFriendlyToParameters();

    const isMobile = breakPoint === "sm" || breakPoint === "xs";

    const configEvent = useMemo(() => getConfiguration(isMobile, forceResultTypeHader, forceMobileColumns, headerRecord, mirs_discipline, hasTableExpanded, config), [breakPoint]);

    const renderRowSubComponent = (React.useCallback(({ row }) => {
        let componentExpanded = hasTableExpanded ? <TableExpanded row={row?.original} config={config} /> : <></>;
        return (
            <LoaderSubComponent component={componentExpanded} />
        )
    }, [hasTableExpanded])
    );

    return (<>
        <MirsTable
            data={recordsData}
            columns={configEvent.columns}
            caption={configEvent.caption}
            keyRow='recordId' //Clave por fila
            initialSortBy={configEvent.sortBy}
            hiddenColumns={configEvent.hiddenColumns}
            renderRowSubComponent={renderRowSubComponent}
        />

    </>);
}

export default RecordsPrototype;


const getConfiguration = (isMobile, forceResultTypeHader, forceMobileColumns, headerRecord, mirs_discipline, hasTableExpanded) => {
    let configuration = {
        columns: [],
        caption: null,
        hiddenColumns: []
    };

    configuration.columns = getColumns(isMobile, forceResultTypeHader, headerRecord, mirs_discipline, hasTableExpanded);
    configuration.sortBy = [{ id: 'RecordName', desc: false }];
    configuration.hiddenColumns = isMobile && forceMobileColumns && Array.isArray(forceMobileColumns) ? forceMobileColumns : [];

    return configuration;
}

function getColumns(isMobile, forceResultTypeHader, headerRecord, mirs_discipline, hasTableExpanded) {


    const columnsXL = [
        ColumnRecordName({ headerRecord: headerRecord }),
        ColumnRecordValue({ forceResultTypeHader: forceResultTypeHader }),
        ColumnNoc({}),
        ColumnName({ discipline: mirs_discipline }),
        ColumnDate({}),
        ColumnLocation({}),
        ...(hasTableExpanded ? [ColumnExpander({ type: 'alwaysTrue', idNode: 'recordId' })] : [])
    ]

    const columnsSM = [
        ColumnRecordName({
            type: 'code',
            headerRecord: headerRecord,
        }),
        ColumnRecordValue({ forceResultTypeHader: forceResultTypeHader }),
        ColumnNoc({}),
        ColumnName({ discipline: mirs_discipline }),

        ...(hasTableExpanded ? [ColumnExpander({ type: 'alwaysTrue' })] : [])
    ]

    return isMobile ? columnsSM : columnsXL

}



////////////// COLUMNS ////////////////


export function ColumnNoc({

    disableSort = true,
    className = 'text-start d-none d-md-table-cell ',
    headerClassName = 'text-start d-none d-md-table-cell w-5',
    label = 'HeaderNOC',
    remove = false
}) {

    const competition = CompetitionFromStore();
    if (isParalympic(competition) && label === 'HeaderNOC') {
        label = 'HeaderNPC';
    }

    return (
        {
            Header: <Label data={label} />,
            id: 'NOC',
            accessor: 'participant.organisation.code',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                let data = props.cell.row.original?.recordDataFiltered?.competitor?.organisation
                return (<Noc {...data} />)
            }
        }
    )

}

function ColumnName({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-40',
    label = '-',
    hideNoc = false,
    discipline = '',
}) {
    return (
        {
            Header: (props) => {
                const row = props?.data[0]

                let lbl
                if (label !== '-') {
                    lbl = label
                } else if (row?.record?.event.includes('K4')) {

                    lbl = 'HeaderTeam'
                } else if (discipline === 'ROW') {
                    lbl = 'HeaderCrew'

                } else {
                    lbl = 'HeaderName'

                }

                return (
                    <Label data={lbl} />
                )
            },
            accessor: 'recordDataFiltered.competitor.code',
            id: 'Name',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            Cell: (props) => {

                let row = props.cell.row.original;
                if (!row?.recordDataFiltered?.competitor) {
                    return ''
                }
                let name;
                let shortName;
                let athlete;
                let athleteName;
                let athleteShortName;
                let haslink = true;
                let dataParticipant = row?.recordDataFiltered?.competitor?.participant

                if (row?.recordDataFiltered?.competitor?.athletes && Array.isArray(row?.recordDataFiltered?.competitor?.athletes) && row?.recordDataFiltered?.competitor?.athletes.length > 0) {
                    athlete = row?.recordDataFiltered?.competitor?.athletes[0];
                    athleteName = `${athlete?.familyName?.toUpperCase()} ${(athlete?.givenName) ? athlete?.givenName:''}`;
                    athleteShortName = `${athlete?.familyName?.toUpperCase()} ${(athlete?.givenName) ? athlete?.givenName?.slice(0, 1) : ''}`;

                }

                if (row?.recordDataFiltered?.competitor?.participant) {
                    name = row?.recordDataFiltered?.competitor?.participant?.name;
                    shortName = row?.recordDataFiltered?.competitor?.participant?.shortName;

                    name = name ? name : athleteName ? athleteName : '';
                    shortName = shortName ? shortName : athleteShortName ? athleteShortName : '';

                    dataParticipant.name = name;
                    dataParticipant.shortName = shortName;

                } else if (athleteName) {
                    dataParticipant = { name: athleteName, shortName: athleteShortName };
                    dataParticipant.organisation = row?.recordDataFiltered?.competitor?.organisation
                }

                //let data = row?.recordDataFiltered?.competitor?.participant

                haslink = row?.recordDataFiltered?.competitor?.participant?.code === undefined ? true : false
                let out;
                if (name) {
                    out = <Competitor {...dataParticipant} hidePicture={true} hideNoc={hideNoc} noLink={haslink} />
                } else if (row?.notEstablished) {
                    out = <SportCode code={row?.notEstablishedLabel} discipline={discipline} entity="@NoRecord" />
                } else { out = '' }

                return (out)

            }
        }
    )
}

function ColumnLocation({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-25',
    label = 'HeaderLocation',
    accessor = 'recordDataFiltered.place'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Location'
        }
    )
}

function ColumnDate({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-10',
    label = 'HeaderDate',
    accessor = 'recordDataFiltered.recordDate'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Date',
            Cell: (props) => {
                if (props.cell.row.original?.recordDataFiltered?.recordDate) {
                    return dateFormat(props.cell.row.original?.recordDataFiltered?.recordDate, "", "MMM D, YYYY");
                }
                return '';
            }
        }
    )
}

function ColumnRecordName({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-15',
    label = 'HeaderRecord',
    type = 'description',
    headerRecord = '',
}) {
    return (
        {
            Header: (props) => {
                let labelCode = headerRecord ? headerRecord : <><Label data={label} /></>;
                return (labelCode)
            },
            accessor: 'order',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'RecordName',
            Cell: (props) => (
                type === 'description'
                    ? props.cell.row.original?.recordType?.description
                    : props.cell.row.original?.recordType?.code?.substring(3)
            )
        }
    )
}

function ColumnRecordValue({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-10',
    label = "",
    resultType = "",
    forceResultTypeHader = undefined
}) {
    return (
        {
            Header: (props) => {
                const resultType = props?.data[0]?.recordDataFiltered?.resultType;
                let labelCode = resultType === 'DISTANCE' ? 'HeaderDistance' : resultType === 'POINTS' ? 'HeaderPoints' : resultType === 'TIME' ? 'HeaderTime' : 'HeaderResult';
                labelCode = forceResultTypeHader ? forceResultTypeHader : labelCode;
                return (<Label data={labelCode} />)
            },
            accessor: 'recordDataFiltered.result',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'RecordValue',
        }
    )
}
